import { connect } from "react-redux";
import React from "react";
import { withRouter } from "react-router-dom";

import { metricsRequests } from "@/api/(requests)/metrics";
import { PSSProviderNoShow } from "@/component-library";

import "./Steps.styles.scss";

const ProviderMessageStep = (props) => {
  const { callDetails, profile } = props;

  const { callId, patient_username, provider_username } = callDetails;

  const { pcp_practice_id } = profile;

  if (!callDetails) {
    return <></>;
  }

  let recordedMetric = {
    entity_id: callId,
    entity_type: "call",
    pk: "provider_no_show",
    segments: [
      {
        segment_id: patient_username,
        segment_type: "patient",
      },
      {
        segment_id: provider_username,
        segment_type: "provider",
      },
      {
        segment_id: pcp_practice_id,
        segment_type: "practice",
      },
    ],
  };

  const onClickConfirm = () => {
    recordedMetric.rank = "message_provider";
    metricsRequests.create_metric(recordedMetric);
    props.history.push(`/app/messages?memberId=${callDetails.provider_username}`);
  };

  const onClickCancel = () => {
    recordedMetric.rank = "no_action";
    metricsRequests.create_metric(recordedMetric);
    props.history.push("/app/home");
  };

  return (
    <div className="d-flex align-items-center my-4 tw:justify-center">
      <PSSProviderNoShow
        className="ProviderMessageStep"
        onClickCancel={onClickCancel}
        onClickConfirm={onClickConfirm}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps)(withRouter(ProviderMessageStep));
